import React from 'react';
import { Route, withRouter } from 'react-router-dom';
import { Button, Icon, LinearProgress } from '@mui/material';
import { NavBarContent } from 'feature/nav/NavBar';
import CourseView from '../CourseView';
import useStyles from './styles';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { get } from 'global/lib/lodash';
import { Row } from 'global/components/row';
import { sortDocs } from '../CourseEditionList';
import { useScreen } from 'global/styles';

const include = ['edition', 'edition.documents', 'edition.documents.document', 'edition.documents.superset', 'edition.documents.reads', 'assessment', 'scorecard', 'user'].join(',');

export const canContinue = (doc, opts = {}) => {
  if (opts.isReview) {
    return true;
  }
  const reads = get(doc, 'reads', []);
  return !!reads.find((r) => !!r.completedAt);
};

export const CourseDocument = withRouter((props) => {
  const { match } = props;

  const { isMobile } = useScreen();
  const classes = useStyles({ isMobile });

  const { id, document } = get(match, 'params', {});

  const locationProps = get(props, 'location.state', {});

  const { data, loading, update } = useRetrieveData(
    { url: `/course-assignments/${id}` },
    {
      useEffect: true,
      build: ['courseAssignments'],
      params: { include },
      transformData: (d) => get(d, '0', {}),
    }
  );

  const documents = sortDocs(get(data, 'edition.documents', []));
  const doc = documents.find((d) => d.id === document);
  const ind = doc ? documents.findIndex((d) => d.id === doc.id) : -1;

  const docIndex = {
    current: ind,
    length: documents.length,
    canNext: canContinue(doc, locationProps) && ind < documents.length - 1,
  };

  const updateAll = async () => {
    await Promise.all([window.CourseEditionUpdate && window.CourseEditionUpdate(), update()]);
  };

  const setDoc = (dir = 1) => {
    const nextDoc = documents[ind + dir] || documents[dir > 0 ? 0 : documents.length - 1];

    props.history.push(`/courses/${id}/document/${nextDoc.id}`, locationProps);
  };

  const pageTitle = () => {
    const isAssessment = get(doc, 'documentableType') === 'assessment';
    return loading ? (
      'Loading...'
    ) : (
      <Row fullWidth>
        {isAssessment ? 'Assessment' : get(doc, 'document.name', '')}
        <Row style={{ marginLeft: 'auto' }}>
          <Button className={classes.headerBtns} disabled={docIndex.current === 0} onClick={() => setDoc(-1)} color="inherit" startIcon={<Icon>keyboard_arrow_up</Icon>}>
            <span className="btnText">Prev</span>
          </Button>
          <Button className={classes.headerBtns} disabled={!docIndex.canNext} onClick={() => setDoc(1)} color="inherit" startIcon={<Icon>keyboard_arrow_down</Icon>}>
            <span className="btnText">Next</span>
          </Button>
        </Row>
      </Row>
    );
  };

  return (
    <div className={classes.content}>
      <NavBarContent pageTitle={pageTitle()} link={{ pathname: '/courses/' + match.params.id, state: locationProps }} />
      {loading && <LinearProgress />}
      <Route
        exact
        path={`/courses/:id/document/:document`}
        render={(props) => <CourseView {...props} docIndex={docIndex} loading={loading} documents={data} document={doc} update={updateAll} setDoc={setDoc} />}
      />
    </div>
  );
});
